<template>
	<div style="max-width: 960px; padding:12px;">
		<v-form>
			<v-card class="mb-4">
				<v-toolbar card prominent>
					<v-toolbar-title class="subheading">{{ template.name }}</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-btn :disabled="!isAdmin" flat @click="editTemplate"> <v-icon class="mr-2">edit</v-icon>Edit Template </v-btn>
				</v-toolbar>

				<v-card-text class="text-xs-left">
					<!-- <h1>{{ template.name }}</h1> -->

					<performance-review-item-builder :edit="false" :review-items="template.reviewItems" />
				</v-card-text>
			</v-card>
		</v-form>
	</div>
</template>

<script>
	import PerformanceReviewItemBuilder from '@/components/performanceReview/PerformanceReviewItemBuilder';

	export default {
		props: {
			template: {
				required: true,
				type: Object
			},
			isAdmin: {
				required: true,
				type: Boolean
			}
		},
		components: {
			PerformanceReviewItemBuilder
		},
		methods: {
			editTemplate() {
				this.$emit('onEdit', this.template.id);
			}
		}
	};
</script>

<style></style>
